<div [ngClass]="type" class="h-[22px] !py-[2px] !px-2 table rounded-2xl !mr-2 leading-[22px]">
    <span class="font-inter !text-xs !font-medium !leading-[18px] table-cell align-middle whitespace-nowrap">{{ item }}</span>
</div>
